export enum VitalTypeEnum {
    HeartRate = 1,
    RespeiratoryRate = 2,
    SystolicBloodPressure = 3,
    DiastolicBloodPressure = 4,
    SystolicHypotension = 5,
    Temperature = 6,
    BloodSuger = 7
}

export enum RangeTypeEnum {
    Normal = 1,
    HidhOrDangerous = 2,
    Critical = 3
}
export enum AgeFactorEnum {
    Hour = 1,
    Day = 2,
    Month = 3,
    Year = 4
}
export enum AwakeOrSleepEnum {
    Awake = 1,
    Sleep = 2
}
export enum MeasurementMethodEnum {
    Rectal = 1,
    Ear = 2,
    Oral = 3,
    Axillary = 4
}